import React, { useRef } from 'react';
import Row from '../layout/Row';
import Input from './Input';


const DateSelector = ({ setDate, searchLimit = 30, ...props }) => {

    const startDateRef = useRef();
    const endDateRef = useRef();

    return (
        <Row>
            <Input
                // ref={startDateRef}
                label='Start Date'
                name='startDate'
                type='date'
                // max={endDateRef.target?.value}
                required
                {...props}
            />
            <Input
                // ref={endDateRef}
                label='End Date'
                name='endDate'
                type='date'
                // min={startDateRef.target?.value}
                required
                {...props}
            />
        </Row>
    );
}

export default DateSelector;